import { css, cx } from "@emotion/css";
import { tableStyles } from "@octopusdeploy/design-system-components";
import { fontWeight, themeTokens, borderWidth, borderRadius } from "@octopusdeploy/design-system-tokens";
import type { SpaceUsage } from "@octopusdeploy/octopus-server-client";
import React from "react";
interface UsageDetailTableProps {
    spacesUsage: SpaceUsage[];
    isPtm: boolean;
}
const UsageDetailTable: React.FC<UsageDetailTableProps> = ({ spacesUsage = [], isPtm }) => (<table className={cx(usageDetailTableStyles.borderedContainer, tableStyles)}>
        <thead>
            <tr>
                <th>Space</th>
                <th>Project</th>
                <th>Tenants</th>
                <th>{isPtm ? "Machines" : "Targets"}</th>
            </tr>
        </thead>
        <tbody>
            {spacesUsage.length > 0 ? (spacesUsage.map((usage) => (<tr key={usage.SpaceName}>
                        <td className={usageDetailTableStyles.spaceNameColumn}>
                            <span>{usage.SpaceName}</span>
                        </td>
                        <td>{usage.ProjectsCount}</td>
                        <td>{usage.TenantsCount}</td>
                        <td>{usage.MachinesCount}</td>
                    </tr>))) : (<tr>
                    <td colSpan={4}>No usage data found.</td>
                </tr>)}
        </tbody>
    </table>);
UsageDetailTable.displayName = "UsageDetailTable"
const usageDetailTableStyles = {
    borderedContainer: css({
        border: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        borderRadius: borderRadius.medium,
        overflow: "clip",
    }),
    spaceNameColumn: css({
        "& > span": {
            fontWeight: fontWeight["700"],
        },
    }),
};
export { UsageDetailTable };
